import { render, staticRenderFns } from "./msgModal.vue?vue&type=template&id=c9cebaa6&scoped=true&"
import script from "./msgModal.vue?vue&type=script&lang=js&"
export * from "./msgModal.vue?vue&type=script&lang=js&"
import style0 from "./msgModal.vue?vue&type=style&index=0&id=c9cebaa6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cebaa6",
  null
  
)

export default component.exports